// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top{width:80%;display:flex;flex-direction:row;justify-content:flex-start;align-items:center}.el-table .hidden_box{display:none}", ""]);
// Exports
module.exports = exports;
